import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { takeUntil } from 'rxjs';

/* Models */
import { Employee } from '../../core/models/employee-view';
import { User } from '../../core/models/user-account';
import { TicketView, GetTicketViewBody, TicketDetails, NewTicket } from '../../core/models/ticket';

/* Services */
import { BaseComponent } from 'src/app/base/base/base.component';
import { BaseService } from 'src/app/core/services/base.service';
import { UserService } from '../../core/services/user-main.service';
import { EmployeeService } from '../../core/services/employee.service';
import { TokenAuthService } from '../../core/services/tokenauth.service';
import { TicketService } from '../../core/services/tickets.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-help-hesk',
  templateUrl: './help-hesk.component.html',
  styleUrl: './help-hesk.component.scss' // keep your existing config
})
export class HelpHeskComponent extends BaseComponent implements OnInit {
  @ViewChild('NewTicketForm') NewTicketForm?: NgForm;

  employee = {} as Employee;
  employeeId = 0;
  loadingEmployee = false;

  user = {} as User;
  userId = 0;

  // New Ticket
  newTicketpopup = false;
  savingNewTicket = false;
  newTicket = {} as NewTicket;
  newTicketObj: FormData = new FormData();

  // Chat UI
  isOpen = false;
  submitSuccess = false; // shows success GIF + actions

  constructor(
    private employeeService: EmployeeService,
    public translate: TranslateService,
    private cd: ChangeDetectorRef,
    private router: Router,
    public baseService: BaseService,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private userService: UserService,
    private tokenAuthService: TokenAuthService,
    private ticketService: TicketService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    const currentUser = this.tokenAuthService.currentUserValue();
    this.userId = currentUser.userId;
    this.employeeId = currentUser.empId;

    if (currentUser.empId !== 0) {
      await this.loadEmployeeData();
    } else {
      await this.loadUserData();
    }
  }

  // === Chat open/close ===
  toggle() {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) this.resetToFormState();
  }

  closeChat() {
    this.isOpen = false;
    this.resetToFormState();
  }

  createNewTicket() {
    this.submitSuccess = false;
    this.resetForm();
  }

  private resetToFormState() {
    this.submitSuccess = false;
    this.resetForm();
  }

  private resetForm() {
    this.newTicket = {} as NewTicket;
    this.newTicketObj = new FormData();
    this.NewTicketForm?.resetForm();
  }

  // === Data loads ===
  private loadEmployeeData(): Promise<void> {
    this.loadingEmployee = true;
    return new Promise((resolve) => {
      this.employeeService
        .getEmpByIdDetails(this.employeeId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          this.employee = data.result.returnData;
          this.loadingEmployee = false;
          resolve();
        });
    });
  }

  private loadUserData(): Promise<void> {
    this.loadingEmployee = true;
    return new Promise((resolve) => {
      this.userService
        .getUserDataById(this.userId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((data: any) => {
          this.user = data.result.returnData;
          this.loadingEmployee = false;
          resolve();
        });
    });
  }

  // === Submit ticket ===
  submitTicket() {
    this.savingNewTicket = true;

    // Always start with a fresh FormData (avoid accumulating duplicate fields)
    this.newTicketObj = new FormData();

    this.newTicketObj.append('author', String(this.userId));
    this.newTicketObj.append('category', '20');
    this.newTicketObj.append('message', this.newTicket.message);
    this.newTicketObj.append('subject', this.newTicket.subject);
    this.newTicketObj.append('priority', 'متوسطة');

    if (this.employeeId !== 0) {
      this.newTicketObj.append('name', this.employee.nameAr);
      this.newTicketObj.append('email', this.employee.personalEmail);
    } else {
      this.newTicketObj.append('name', this.user.name);
      this.newTicketObj.append('email', this.user.emailAddress);
    }

    this.ticketService
      .AddNewTicket(this.newTicketObj)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: any) => {
          this.savingNewTicket = false;

          if (data?.message === 'Ticket Added Successfully') {
            // Show success view (GIF + actions)
            this.submitSuccess = true;
            // Clear form so if user clicks "Create new ticket" it's fresh
            this.resetForm();
          } else {
            // keep the form; optionally show an error toast/snackbar
          }
        },
        (error) => {
          this.savingNewTicket = false;
          // optionally show an error toast/snackbar
        }
      );
  }
}
